import { useEffect, type CSSProperties } from 'react'
import { NovaLogo } from './NovaLogo'
import '../styles/asset-loader.css'

type AssetLoaderProps = {
  loading: boolean
  completed: number
  total: number
  onSkip: () => void
}

export function AssetLoader({ loading, completed, total, onSkip }: AssetLoaderProps) {
  const progress = total ? completed / total : 0

  useEffect(() => {
    if (!loading) return
    const root = document.documentElement
    const previousOverflow = root.style.overflow
    const previousGutter = root.style.scrollbarGutter
    root.style.scrollbarGutter = 'stable'
    root.style.overflow = 'hidden'
    return () => {
      root.style.overflow = previousOverflow
      root.style.scrollbarGutter = previousGutter
    }
  }, [loading])

  return (
    <div
      className="asset-loader"
      data-loading={loading}
      aria-hidden={!loading}
      inert={!loading}
      style={{ '--asset-progress': progress } as CSSProperties}
    >
      <div className="asset-loader__brand"><NovaLogo /></div>
      <div className="asset-loader__signal" aria-hidden="true">
        <span />
        <svg viewBox="0 0 200 200" focusable="false">
          <path d="M100 24C107 84 116 93 190 100C116 107 107 116 100 176C93 116 84 107 10 100C84 93 93 84 100 24Z" />
        </svg>
      </div>
      <div className="asset-loader__content">
        <p className="signal-label">NOVA ENERGY // FIRST CONTACT</p>
        <p className="asset-loader__title">Acquiring<br />the signal.</p>
        <div className="asset-loader__readout">
          <span role="status">Loading the Nova universe…</span>
          <span aria-hidden="true">{String(Math.round(progress * 100)).padStart(2, '0')}%</span>
        </div>
        <div
          className="asset-loader__progress"
          role="progressbar"
          aria-label="Nova visual assets"
          aria-valuemin={0}
          aria-valuemax={total}
          aria-valuenow={completed}
          aria-valuetext={`${completed} of ${total} visual assets ready`}
        ><span /></div>
        <button className="asset-loader__skip" type="button" onClick={onSkip}>
          Continue in lightweight mode <span aria-hidden="true">↗</span>
        </button>
      </div>
      <p className="asset-loader__footer">THREE FREQUENCIES. ONE SOURCE.</p>
    </div>
  )
}
